import { ProjectPondParameterBase } from './base/project-pond-parameter-base';

export class ProjectPondParameter extends ProjectPondParameterBase { }